import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagination, Table, TableAction, TableActions, TableData, TableDataTypes } from '../../shared/types';
import { LoaderService } from '../../loader.service';
import { AlertDialogService } from '../../shared/alert-dialog/alert-dialog.service';
import { SubscriptionService } from '../subscription.service';
import { AuthzAccessHintService } from '../../shared/authz-access-hint/authz-access-hint.service';
import { AUTHZ_FEATURES } from '../../constants/permissions';
var ConfigRequestListComponent = /** @class */ (function () {
    function ConfigRequestListComponent(route, router, subscriptionService, loaderService, alertDialogService, authzAccessHintService) {
        this.route = route;
        this.router = router;
        this.subscriptionService = subscriptionService;
        this.loaderService = loaderService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.title = 'Config Requests';
        this.authzAccessHint = null;
        this.kind = 'subscription';
        var data = this.route.snapshot.data || {};
        this.kind = data.kind || 'subscription';
        this.title = data.title || this.title;
        this.table = new Table({
            headers: this.headers(),
            pagination: new Pagination(0, 15, 0, [15, 20]),
            data: [],
            sortableColumnKeys: []
        });
    }
    ConfigRequestListComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var feature, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        feature = this.kind === 'billingPlan' ? AUTHZ_FEATURES.BILLING_PLANS : AUTHZ_FEATURES.SUBSCRIPTION;
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData(feature)];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        this.fetchTableData();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigRequestListComponent.prototype.fetchTableData = function () {
        var _this = this;
        this.loaderService.openLoading();
        var page = this.table.pagination.pageNo || 0;
        var limit = this.table.pagination.perPage || 15;
        this.subscriptionService.getConfigRequests(this.kind, page, limit).subscribe(function (response) {
            var rows = (response && response.data) || [];
            _this.table.pagination.count = (response && response.documentCount) || 0;
            _this.table.data = rows.map(function (row) { return _this.toRow(row); });
            _this.loaderService.closeLoading();
        }, function (error) {
            _this.table.data = [];
            _this.loaderService.closeLoading();
            var body = error && error.error;
            var message = (body && (body.message || body.errorMessage)) || 'Could not load config requests';
            _this.alertDialogService.open({ title: 'Config requests', message: message, confirmText: 'OK' });
        });
    };
    ConfigRequestListComponent.prototype.headers = function () {
        if (this.kind === 'billingPlan') {
            return {
                status: 'Status',
                cities: 'City',
                zoneNames: 'Zone',
                name: 'Name',
                serviceNames: 'Service',
                startDate: 'Start Date',
                endDate: 'End Date',
                userSelector: 'User Selector',
                priority: 'Priority',
                action: 'Actions'
            };
        }
        return {
            status: 'Status',
            cities: 'City',
            name: 'Name',
            serviceNames: 'Service',
            startDate: 'Start Date',
            endDate: 'End Date',
            type: 'Type',
            priority: 'Priority',
            action: 'Actions'
        };
    };
    ConfigRequestListComponent.prototype.toRow = function (row) {
        var _this = this;
        var common = {
            id: row._id,
            status: this.statusLabel(row.requestStatus),
            cities: row.cities || '--',
            name: row.name || '--',
            serviceNames: row.serviceNamesShort || row.serviceNames || '--',
            startDate: row.startDate || '--',
            endDate: row.endDate || '--',
            priority: row.priority != null ? row.priority : '--',
            action: new TableData({
                type: TableDataTypes.ACTION,
                actions: new TableActions([
                    new TableAction({
                        text: 'View',
                        onClick: function (data) {
                            var base = _this.kind === 'billingPlan' ? '/accessfee/rule-requests' : '/subscription/rule-requests';
                            _this.openPage(base + "/" + data.id);
                        }
                    })
                ])
            })
        };
        if (this.kind === 'billingPlan') {
            return Object.assign(common, {
                zoneNames: row.zoneNames || '--',
                userSelector: row.userSelector || 'No'
            });
        }
        return Object.assign(common, {
            type: this.typeLabel(row)
        });
    };
    ConfigRequestListComponent.prototype.openPage = function (url) {
        window.open(this.router.serializeUrl(this.router.createUrlTree([url])));
    };
    ConfigRequestListComponent.prototype.statusLabel = function (status) {
        if (!status) {
            return '--';
        }
        var value = String(status).toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
    };
    ConfigRequestListComponent.prototype.typeLabel = function (row) {
        var planType = row.planType === 'REGULAR' || row.planType === 'PREPAID' ? 'PREPAID' : (row.planType || '--');
        return planType + "\n" + (row.validityType || '--');
    };
    return ConfigRequestListComponent;
}());
export { ConfigRequestListComponent };
